<template>
  <div class="panel">
    <div class="panel-body" v-loading="loading">
      <el-form label-position="top" :model="formData" ref="formData">
        <el-card class="box-card">
          <form-title
            :base="base"
            :hasLog="false"
            slot="header"
          >
          </form-title>
          <base-field
            v-if="isEdit"
            :base="base"
            :formData="formData"
          >
          </base-field>
          <text-field
            v-model="formData[fkIDName]"
            :base="base"
            :name="fkIDName"
            :disabled="true"
          >
          </text-field>
          <text-field
            v-model="formData.to_email"
            :base="base"
            type="textarea"
            name="to_email"
          >
          </text-field>
          <text-field
            v-model="formData.cc"
            :base="base"
            type="textarea"
            name="cc"
          >
          </text-field>
          <text-field
            v-model="formData.bcc"
            :base="base"
            type="textarea"
            name="bcc"
          >
          </text-field>
          <el-row :gutter="20">
            <el-col :xs="24" :md="12">
              <text-field
                v-model="formData.from_name"
                :base="base"
                name="from_name"
                :required="true"
              >
              </text-field>
            </el-col>
            <el-col :xs="24" :md="12">
              <text-field
                v-model="formData.from_email"
                :base="base"
                name="from_email"
                :required="true"
              >
              </text-field>
            </el-col>
          </el-row>
          <text-field
            v-model="formData.subject"
            :base="base"
            name="subject"
            :required="true"
          >
          </text-field>
          <tinymce
            id="emailContent"
            v-model="formData.content"
            :plugins="tinymcePlugins"
          >
          </tinymce>
          <std-opt
            v-model="formData.status"
            :base="base"
            name="status"
            type="email"
            :disabled="true"
          >
          </std-opt>
          <form-btn
            :base="base"
            :isEdit="isEdit"
            :create="create"
            :hasSave="checkStatus()"
            :hasSaveAs="true"
            :formValid="formValid"
            :formData="formData"
            :updateOne="updateOne"
          >
          </form-btn>
        </el-card>
      </el-form>
    </div>
  </div>
</template>

<script>

const defFormData = {
  id: undefined,
  created_at: undefined,
  updated_at: undefined,
  status: 0
}

export default {
  name: 'email-detail',
  props: {
    base: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    fkIDName: {
      type: String,
      required: true
    },
    fetchOne: {
      type: Function,
      required: true
    },
    updateOne: {
      type: Function,
      required: true
    },
    create: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      dataId: '0',
      formData: Object.assign({}, defFormData),
      loading: false,
      formValid: () => {},
      tinymcePlugins: ['advlist autolink lists link image charmap print preview hr anchor pagebreak',
        'searchreplace wordcount visualblocks visualchars code fullscreen fullpage autoresize',
        'insertdatetime media nonbreaking save table contextmenu directionality',
        'template paste textcolor colorpicker textpattern imagetools toc help emoticons hr']
    }
  },
  created () {
    if (this.isEdit) {
      this.dataId = this.$route.params && this.$route.params.id
      this.fetchData(this.dataId)
    } else {
      this.formData = JSON.parse(JSON.stringify(defFormData))
    }
  },
  mounted () {
    this.formValid = this.$refs.formData.validate
  },
  methods: {
    checkStatus () {
      return (this.formData.status <= 1)
    },
    fetchData (id) {
      this.loading = true
      this.fetchOne(id).then(response => {
        this.formData = response.data
      }).catch(err => {
        console.log(err)
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
